module.exports = __webpack_public_path__ + "img/jiuyue.017a85fa.jpg";